export default "__VITE_ASSET__BwA6JlxR__"